import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('home_targets')
            .then(result => {
                self.targets = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
    save() {
        const self = this,
            api = getApiClient(self.$store)

        self.targets.forEach((target, index) => {
            api.patch(target['@id'], {
                items: target.items
            }, {
                headers: {
                    'Content-Type': 'application/merge-patch+json'
                }
            })
                .then(() => {
                    self.load()
                    self.changed = false
                })
                .catch((error) => {
                    console.log(error)
                })
        })
    },
    append(target) {
        target.items.push('')
        this.changed = true
    },
    remove(target, index) {
        this.$delete(target.items, index)
        this.changed = true
    }
}
